import { Button, Link } from "./style";

import React from "react";
import withRouter from "react-router-dom/withRouter";

export default withRouter(function BackButton({ history, to }) {
  return to ? (
    <Link to={to}>Retour</Link>
  ) : (
    <Button onClick={history.goBack} activ>
      Retour
    </Button>
  );
});
